import React from 'react';

import ModularCommentDisplay from 'components/Comment/ModularCommentDisplay';
import { useSelector } from 'react-redux';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';
import styled from 'styled-components';

export default function AutomatedComment({ className, ...props }) {
  const fromEmployeeId = props.fromEmployee?.id || null;
  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId);
  const isLoggedInEmployee = fromEmployeeId === loggedInEmployeeId;
  return (
    <StyledCommentDisplay
      isLoggedInEmployee={fromEmployeeId === loggedInEmployeeId}
      className={`${className} automatedComment`}
      {...props}
    >
      {!isLoggedInEmployee && <StyledCreatedAt color="textSecondary" variant="caption" />}
      <MessageItemContainer isLoggedInEmployee={isLoggedInEmployee}>
        <ModularCommentDisplay.From display="inline" weight={600} variant="caption" />{' '}
        <MessageContainer isLoggedInEmployee={isLoggedInEmployee}>
          <ModularCommentDisplay.Message variant="caption" />
        </MessageContainer>
      </MessageItemContainer>
      {isLoggedInEmployee && <StyledCreatedAt color="textSecondary" variant="caption" />}
    </StyledCommentDisplay>
  );
}

const StyledCreatedAt = styled(ModularCommentDisplay.CreatedAt)`
  visibility: hidden;
  width: calc(35px + 1.5rem);
  text-align: center;
  margin-top: 1px;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
`;

const StyledCommentDisplay = styled(ModularCommentDisplay)`
  display: flex;
  justify-content: ${(props) => (props.isLoggedInEmployee ? 'flex-end' : 'flex-start')};
  &:hover ${StyledCreatedAt} {
    visibility: visible;
  }
`;

const MessageItemContainer = styled.div`
  max-width: 70%;
  text-align: ${(props) => (props.isLoggedInEmployee ? 'right' : 'left')};
`;

const MessageContainer = styled.div`
  display: inline;
  text-align: ${(props) => (props.isLoggedInEmployee ? 'right' : 'left')};
`;

// ${props =>
//   props.isLoggedInEmployee
//     ? css`
//         margin-right: calc(35px + 1rem);
//       `
//     : css`
//         margin-left: calc(35px + 1rem);
//       `};
